import React, { useEffect, useState } from "react";
import './Profil.css';
import { useNavigate } from 'react-router-dom';
import { loadUser } from '../../services/api';

const Profil = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('token');
  const username = localStorage.getItem('login');
  const navigate = useNavigate();

  useEffect(() => {
       
    const fetchUser = async () => {
      try {
        const data = await loadUser(username, token);
        setUser(data);
      } catch (err) {
        console.error("Erreur API:", err);
        setError("Impossible de charger le profil utilisateur.");
      }
    };

    if (username && token) {
      fetchUser();
    }
  }, [username, token]);

  if (error) {
    return <div className="profil-container"><p>{error}</p></div>;
  }

  if (!user) {
    return <div className="profil-container"><p>Chargement...</p></div>;
  }

  const { personne, roles, typeExamens } = user;

  return (
    <div className="profil-container">
           
      <div className="buttons">
       <button onClick={() => navigate('/accueil')}>
       <span role="img" aria-label="acceuil">🏠</span>Retour à l’accueil
      </button>
      </div>

      <h1 className="profil-title">👤 Profil Utilisateur</h1>

      <div className="section">
        <h2>Informations personnelles</h2>
        <p><span>Nom :</span> {personne?.nom}</p>
        <p><span>Prénom :</span> {personne?.prenom}</p>
        <p><span>Date de naissance :</span> {new Date(personne?.date_naissance).toLocaleDateString('fr-FR')}</p>
        <p><span>Adresse :</span> {personne?.adresse}</p>
        <p><span>Sexe :</span> {personne?.sexe || "Non renseigné"}</p>
      </div>

      <div className="section">
        <h2>Connexion</h2>
        <p><span>Login :</span> {user.login}</p>
      </div>

      <div className="section">
        <h2>Rôles</h2>
        <ul>
          {roles.map((role) => (
            <li key={role.id}>{role.libelle}</li>
          ))}
        </ul>
      </div>

      <div className="section">
        <h2>Types d'examens autorisés</h2>
        <ul>
          {typeExamens.map((type) => (
            <li key={type.id}>{type.libelle}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Profil;
